import { IEvent } from '../../interfaces/events/event.interface';
import { IPlayerData } from '../../interfaces/player/player.interface';
import { IOrganizationInfo } from '../../interfaces/user/user.interface';
import { IAlertData, IToastConfig } from '../../interfaces/utils/utils.interface';
import { EventsService } from '../../services/events/events.service';

export class SitePageClass {

  protected orgName: string = '';
  protected orgNameLong: string = '';
  protected orgId: number = 0;
  protected eventsLive: IEvent[] = [];
  protected eventsScheduled: IEvent[] = [];
  protected eventsArchived: IEvent[] = [];
  protected eventsFinished: IEvent[] = [];
  protected watchToken: string | undefined;
  protected isPlayerLive: boolean = false;

  protected playerDataready: boolean = false;
  protected playerData: IPlayerData = {
    id: 0,
    name: 'Name',
    token: '',
    start: new Date(),
    protected: false,
    password: '',
    status: ''
  }

  constructor(protected events: EventsService) {
  }

  protected init(addr: string): void {
    this.orgName = addr.slice(1,);
    console.log('[SitePageComponent] ngAfterViewInit ' + this.orgName);

    try{
      this.events.getOrganizationInfoByAlias(this.orgName)
          .pipe()
          .subscribe((org: IOrganizationInfo | null) => {
            if (org != null) {
              if ((org.id !== undefined)&&
                  (org.name !== undefined)){
                this.orgId = org.id;
                this.orgNameLong = org.name;
                this.updateEventList();
              }
            }
            else{
              this.exitPage();
            }
          });
    }
    catch(err){
      this.exitPage();
    }
  }

  protected destroy() {
  }

  protected exitPage(): void {
    // must be overridden
  }

  protected displayToast(config: IToastConfig): void {
    // must be overridden
  }
  protected displayAlert(data: IAlertData): void {
    // must be overridden
  }

  protected updateEventList(){
    this.events.getEventsByStatus('Running', this.orgId)
      .pipe()
      .subscribe(list => {
        if ((list !== null)&&(list !== undefined)){
          this.eventsLive = list;
          if ((this.eventsLive.length > 0)&&(this.watchToken === undefined)){
            this.setPlayerEvent(this.eventsLive[0].viewerToken, true);
          }
        }
    });
    this.events.getEventsByStatus('Scheduled', this.orgId)
      .pipe()
      .subscribe(list => {
        if ((list !== null)&&(list !== undefined)){
          this.eventsScheduled = list;
          //this.setPlayerEvent(this.eventsScheduled[0].viewerToken, true);
        }
    });
    this.events.getEventsByStatus('Finished', this.orgId)
      .pipe()
      .subscribe(list => {
        console.log('[SitePageClass] updateEventList: ' + JSON.stringify(list))
        if ((list !== null)&&(list !== undefined)){
          this.eventsFinished = list;
          //this.setPlayerEvent(this.eventsArchived[0].viewerToken);
        }
    });
    this.events.getEventsByStatus('Archived', this.orgId)
      .pipe()
      .subscribe(list => {
        if ((list !== null)&&(list !== undefined)){
          this.eventsArchived = list;
          //this.setPlayerEvent(this.eventsArchived[0].viewerToken);
        }
    });
  }

  protected onClickEvent(token: string, isLive: boolean){
    //LIVE PLAYER TEMPORARILY DISABLED
    this.setPlayerEvent(token, isLive);
    //this.goToSection(token, true);
  }

  protected setPlayerEvent(token: string | undefined, isLive: boolean){
    this.watchToken = token;
    this.isPlayerLive = isLive;
    console.log('[SITE PAGE CLASS] - setPlayerEvent - Event token: ' + this.watchToken + ', Live: ' + this.isPlayerLive);
  }

  protected goToSection(token: string, newWindow: boolean){
    //MUST OVERRIDE
  }

  protected onClickRefresh(){
    this.updateEventList();
  }
}
